import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminLayout from "@/components/AdminLayout";
import Dashboard from "@/components/Dashboard";
import Login from "@/pages/Login";
import ChannelsPage from "@/pages/ChannelsPage";
import RulesPage from "@/pages/RulesPage";
import SettingsPage from "@/pages/SettingsPage";

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route
                            element={
                                <ProtectedRoute>
                                    <AdminLayout />
                                </ProtectedRoute>
                            }
                        >
                            <Route path="/" element={<Dashboard />} />
                            <Route path="/channels" element={<ChannelsPage />} />
                            <Route path="/rules" element={<RulesPage />} />
                            <Route path="/settings" element={<SettingsPage />} />
                        </Route>
                    </Routes>
                </BrowserRouter>
            </AuthProvider>
            <Toaster
                theme="dark"
                position="bottom-right"
                toastOptions={{
                    style: {
                        background: "#0c1016",
                        border: "1px solid #2a3a52",
                        color: "#e6edf3",
                        fontFamily: "JetBrains Mono, monospace",
                        fontSize: "12px",
                    },
                }}
            />
        </div>
    );
}

export default App;
